import { Link } from "react-router-dom";
import { BrandHeader } from "../components/BrandHeader";

export function PrivacyPage() {
  return (
    <div className="page-shell">
      <BrandHeader />
      <main className="content-shell prose-page">
        <p className="eyebrow">Privacy</p>
        <h1>How your Friction Finder information is handled</h1>
        <p>Your assessment answers remain in your current browser session until you submit them, restart the Friction Finder or the browser session ends.</p>
        <p>Contact details are only collected when you choose to send your Friction Snapshot. Submitted information is securely stored in HuddleCo’s server database and is available only to authorised HuddleCo users through the protected internal page.</p>
        <p>HuddleCo may use the information you submit to contact you about your Friction Snapshot. Assessment answers are not used to make automated decisions.</p>
        <p>Do not enter sensitive personal information in custom response fields. You may contact HuddleCo to request access to, correction of or deletion of your submitted personal information.</p>
        <p>Database backups, server logs and exported submission records are treated as confidential business data.</p>
        <Link className="text-link" to="/">Return to the Friction Finder</Link>
      </main>
    </div>
  );
}
